<template>

        <div class="vch-my-information">
            <div class="vch-grid mb-xl">
                <h2 class="vch-col-12 vch-col-md-6 vch-col-xl-4 heading-xl uppercase">{{infoTitle}}</h2>
            </div>
            <template>
                <div class="vch-grid">
                    <div class="
                            vch-col-offset-md-3
                            vch-col-12
                            vch-col-md-10
                            vch-col-offset-md-1
                            vch-col-lg-10
                            vch-col-offset-lg-2
                            vch-col-xl-6
                            vch-col-offset-xl-3
                        ">
                    <div class="information-block">
                        <h3 class="user-title heading-xl uppercase">
                            {{ infoUserHead }}
                        </h3>
                        <div v-html="addressInfo"></div>
                        <a class="update-pwd" :href="updateLink">{{updateInfo}}</a>
                    </div>
                    </div>
                
                </div>
            </template>
            <template>
                <div class="vch-grid">
                    <div class="
                            vch-col-offset-md-3
                            vch-col-12
                            vch-col-md-10
                            vch-col-offset-md-1
                            vch-col-lg-10
                            vch-col-offset-lg-2
                            vch-col-xl-6
                            vch-col-offset-xl-3
                        ">
                    <div class="information-block">
                        <h3 class="user-title user-creds heading-xl uppercase">
                            {{ infoUserCred }}
                        </h3>
                        <div class="vch-grid">
                            <div class="vch-info-common-block vch-col-12 vch-col-md-4">
                                <h4>{{emailTitle}}</h4>
                                <p>{{emailAddress}}</p>
                            </div>   
                            <div class="vch-info-common-block vch-col-12 vch-col-md-4">
                                <h4>{{pwdTitle}}</h4>
                                <p>{{pwdResult}}</p>
                            </div> 
                            <div class="vch-info-common-block vch-col-12 vch-col-md-4">  
                                <a class="change-pwd" :href="updatepwdLink">{{updatePwd}}</a>
                            </div>   
                        </div>     
                    </div>
                        

                    </div>
                
                </div>
            </template>
        </div>
        
</template>
<script>
export default {
    name: 'vch-my-information',
    props: {
        infoHead: {
            type: String,
            required: true,
        },
        infoUserHead: {
            type: String,
            required: true,
        },
         infoUserCred: {
            type: String,
            required: true,
        },
        addressInfo: {
            type: String,
            required: true,
        },
        emailTitle: {
            type: String,
            required: true,
        },
        emailAddress: {
            type: String,
            required: true,
        },
       pwdTitle: {
            type: String,
            required: true,
        },
        pwdResult: {
            type: String,
            required: true,
        },
        updateInfo: {
            type: String,
            required: true,
        },
        updatePwd: {
            type: String,
            required: true,
        },
        updateLink: {
            type: String,
            required: true,
        },
        updatepwdLink: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            infoTitle: this.infoHead,
            userHead: this.infoUserHead,
            userAddress: this.addressInfo,
            userCred: this.infoUserCred,
            userEmail: this.emailTitle,
            useraddress: this.emailAddress,
            userPwd: this.pwdTitle,
            userPwdresult: this.pwdResult,
            pwdUpdate: this.updatePwd,
            infoUpdate: this.updateInfo,
            updatelink:this.updateLink,
            updatepwdlink:this.updatepwdLink,

        };
    },
}
</script>
<style lang="scss" src="./my-information.scss" scoped></style>